import { IDeleteObrasGestaoDeResiduosUseCase } from "../../../presentation/useCases/delete/delete_obras_gestao_de_residuos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObrasGestaoDeResiduosUseCase
 */

export class DeleteObrasGestaoDeResiduosUseCase implements IDeleteObrasGestaoDeResiduosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteObrasGestaoDeResiduos(id?: number): Promise<void> {
    await this.repository.deleteGestaoResiduos({ id });
  }
}
